module.exports = __webpack_public_path__ + "img/main.6fbaee9a.jpg";